export default {
    reviewOrder: {
        reviewOrder: "Revisar pedido"
    }
}